import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Store from "./Store";
import Homepage from "./pages/Homepage";
import Migration from "./pages/Migration";

export default function Navigation() {
  return (
    <Store>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<Homepage />} />
          <Route path={"/migrate"} element={<Migration />} />
        </Routes>
      </BrowserRouter>
    </Store>
  );
}
